import {FirebaseAuthProvider} from './FirebaseAuthProvider';
import firebase from 'firebase/compat/app';
import {useAuthState} from 'react-firebase-hooks/auth';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import {firebaseConfig} from '../../config';
import {Login} from './Login';
import {Loading} from '../loading/Loading';
import {EventsProvider} from '../../course/contexts/EventsContext';
import {useLocation} from 'react-router-dom';
import {useActiveRoom} from '../../firebase/realtime/Rooms';
import {database} from 'firebaseApp';
import {ApplicationVersionMonitor} from './ApplicationVersionMonitor';
import {ExperimentProvider} from 'contexts/ExperimentContext';
import {BanditProvider} from 'experiments/BanditContext';
import {ActiveExperimentsProvider} from 'experiments/ActiveExperimentsContext';
import {useIdleTimer} from 'react-idle-timer';
import {getAuth} from 'firebase/auth';
import {useContext} from 'react';
import {CourseIdContext} from 'contexts/CourseContext';
import {CourseThemeProvider} from 'course/contexts/ThemeContext';
import {useCoursePresenceCheckIn} from 'coursePresence/useCoursePresenceCheckIn';

const loggingCourses = [
  'cip3',
  'public',
  'cip4',
  'cip5',
  'pylatino-25',
  'cip6',
  'cip7',
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
export const Authenticated = ({component: Component, ...props}) => {
  return (
    <FirebaseAuthProvider>
      <LoginHelper component={Component} />
    </FirebaseAuthProvider>
  );
};

// For published page in particular, where you don't have to be authenticated, but if you are, you can edit it!
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
export const AuthenticatedOptional = ({component: Component, ...props}) => {
  return (
    <FirebaseAuthProvider>
      <AuthenticatedOptionalHelper component={Component} />
    </FirebaseAuthProvider>
  );
};

export const AuthenticatedOptionalHelper = ({
  component: Component,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  ...props
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const [user, loading] = useAuthState(getAuth());

  return <Component user={user} />;
};

// TODO: make events optional
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
const LoginHelper = ({component: Component, ...props}) => {
  const [user, loading] = useAuthState(getAuth());
  const courseId = useContext(CourseIdContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const activeRoom = useActiveRoom(user?.uid, courseId);
  useUserPresence(user, courseId);
  useCoursePresenceCheckIn({uid: user?.uid, courseId});

  if (loading) {
    return <Loading />;
  }

  if (!user || (!user.emailVerified && user.providerData.length > 0)) {
    return (
      <CourseThemeProvider courseId={courseId}>
        <Login />
      </CourseThemeProvider>
    );
  }

  return (
    <CourseThemeProvider courseId={courseId}>
      <EventsProvider courseId={courseId}>
        <ApplicationVersionMonitor />
        <ExperimentProvider>
          <BanditProvider>
            {/* Registry of which bandit experiments are actually live on
                the current page (distinct from BanditProvider's course-wide
                snapshot cache) — feeds the admin ExperimentControlPanel
                mounted deeper in the tree, inside CoursePage, where
                ProfileContext (for the admin-role check) is available. */}
            <ActiveExperimentsProvider>
              <Component user={user} />
            </ActiveExperimentsProvider>
          </BanditProvider>
        </ExperimentProvider>
      </EventsProvider>
    </CourseThemeProvider>
  );
};

// time before user is considered idle
const IDLE_TIMEOUT_MS = 1000 * 60 * 15; // 15 minutes

// update user engagnement every 5 seconds
const THROTTLE_ACTIVITY_MS = 1000 * 5; // 5 seconds

const useUserPresence = (user, courseId) => {
  const location = useLocation();

  const isLoggingCourse = loggingCourses.includes(courseId);
  const shouldLog = isLoggingCourse && user;
  const userStatusRef = user
    ? database.ref(`/${courseId}/status/${user.uid}`)
    : null;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const onIdle = (event, idleTimer) => {
    if (userStatusRef && shouldLog) {
      userStatusRef.update({
        is_idle: true,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        timestampLocal: Date.now(),
      });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const onAction = (event, idleTimer) => {
    if (userStatusRef && shouldLog) {
      userStatusRef.set({
        is_idle: false,
        last_engaged_loc: location.pathname,
        last_engaged_time: firebase.database.ServerValue.TIMESTAMP,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        timestampLocal: Date.now(),
        // need this to track people's time differences if ever needed
      });
    }
  };

  // throttle makes surre you fire only once every THROTTLE_ACTIVITY_MS milliseconds
  useIdleTimer({
    onIdle,
    onAction,
    timeout: IDLE_TIMEOUT_MS,
    throttle: THROTTLE_ACTIVITY_MS,
  });
};
